import styled from "styled-components"

export const Container = styled.div`
  padding-top: 2rem;
  margin: 0 auto;
  margin-bottom: 2rem;
  width: 80%;
  height:90vh;
  @media (max-width: 769px) {
    width: 100%;
  }
  
`;